/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import {Observable, catchError, concatMap, from, mergeMap, of} from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { UserPreferences } from '@scenario/models/user-preferences.model';
import { RootState } from '@store/create-store';
import {
  retrieveUserPreferencesFailure,
  retrieveUserPreferencesSuccess,
} from '@store/scenario/user-preferences/user-preferences-slice';
import { retrieveSubscriptions } from '@store/scenario/subscription/subscription-slice';

export const retrieveUserPreferencesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('userPreferences/retrieveUserPreferences'),
    concatMap((_action: Action) =>
      from(dependencies.userPreferencesGateway.retrieve()).pipe(
        mergeMap((userPreferences: UserPreferences) => of(retrieveUserPreferencesSuccess(userPreferences), retrieveSubscriptions())),
        catchError(() => of(retrieveUserPreferencesFailure('Fail to retrieve user preferences'))),
      ),
    ),
  );
